<template>
  <div id="single-file-drag-drop" style="height: 200px;">
    <span style="margin-top: 0px;">Drop file below to upload</span>
    
    <form ref="fileform" style="margin-top: 0px; height: 50px;">
      <!-- <v-icon style="margin-top: 0px; padding-top: 0px;">mdi-target</v-icon> -->
      <!-- <p style="margin-top: 0px;">Drop file here to upload.
        <br/>Change name above if necessary.</p> -->
    </form>
  
    <div >
      <progress max="100" :value.prop="uploadPercentage"></progress>
    </div>
  
  
    <a class="submit-button" v-on:click="submitFiles()" v-show="showButton">Upload</a>
  </div>
</template>

<script>
// import axios from 'axios'
import axiosInstances from '../server/axiosInstances'
import { sync } from 'vuex-pathify'
export default {
  props:['rec', 'name', 'dir', 'fileCallback', 'saveCallback'],
  data () {
    return {
      dragAndDropCapable: false,
      file: null,
      uploadPercentage: 0,
      showButton: false
    }
  },
  computed: {
    // editedItem: sync('dialogEditedItem'),
    user: sync('login/loggedinUser')
  },
  watch: {
    file: {
      handler (val) {
        if (val != null) this.showButton = true
        if (this.fileCallback) this.fileCallback(this.rec, this.name, val)
      }
    }
  },
  mounted () {
    this.file = null
    //  Determine if drag and drop functionality is capable in the browser
    this.dragAndDropCapable = this.determineDragAndDropCapable()
    //  If drag and drop capable, then we continue to bind events to our elements.
    if (this.dragAndDropCapable) {
      /* Listen to all of the drag events and bind an event listener to each
      for the fileform. */
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        /*
          For each event add an event listener that prevents the default action
          (opening the file in the browser) and stop the propagation of the event (so
          no other elements open the file in the browser)
        */
        this.$refs.fileform.addEventListener(evt, function (e) {
          e.preventDefault()
          e.stopPropagation()
        }, // .bind(this),
        false)
      }.bind(this))

      //  Add an event listener for drop to the form
      this.$refs.fileform.addEventListener('drop', function (e) {
        for (let i = 0; i < e.dataTransfer.files.length; i++) {
          this.file = e.dataTransfer.files[i]
          // this.getImagePreviews()
          this.uploadPercentage = 0
          // this.editedItem[this.name] = e.dataTransfer.files[i].name
        }
      }.bind(this))
    }
  },

  methods: {
    //  Determines if the drag and drop functionality is in the window
    determineDragAndDropCapable () {
      /*
        Create a test element to see if certain events
        are present that let us do drag and drop.
      */
      var div = document.createElement('div')

      /*
        Check to see if the `draggable` event is in the element
        or the `ondragstart` and `ondrop` events are in the element. If
        they are, then we have what we need for dragging and dropping files.

        We also check to see if the window has `FormData` and `FileReader` objects
        present so we can do our AJAX uploading
      */
      return (('draggable' in div) ||
        ('ondragstart' in div && 'ondrop' in div)) &&
        'FormData' in window &&
        'FileReader' in window
    },

    /* Submits the files to the server */
    async submitFiles () {
      /* Initialize the form data */
      let formData = new FormData()

      /* Iteate over any file sent over appending the files to the form data. */
      // for (var i = 0; i < this.files.length; i++) {
      //   let file = this.files[i]
      //   formData.append('files[' + i + ']', file)
      // }
      formData.append('files[0]', this.file)
      var self = this
      // for (var value of formData.values()) {
      //   // console.log(value);
      // }
      /* Make the request to the POST /file-drag-drop URL */
      // console.log('Uploading file: ', this.user.org, this.rec, this.editedItem, this.name, this.editedItem[this.name], ' dir: ', this.dir)
      let url = 'files/'+this.user.org+'?subdir='+this.dir/*+'&rename='+this.rec[this.name]*/
      console.log('URL: ', url)
      axiosInstances.apiServer.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
        }.bind(this)
      }
      ).then(function () {
        // self.files = 
        self.showButton = false
        self.uploadPercentage = 0
        if (self.saveCallback) self.saveCallback()
        // self.$store.dispatch('fetchAuthTable', 'ota', true)
        // this.$store.dispatch('fetchDataTable', {name: 'ota', auth: 'loginServer'})
        // console.log('SUCCESS!!')
        // self.$store.commit('SET_ALERT', {
        //   show: true,
        //   msg: 'SUCCESS',
        //   color: 'success'
        // })
      })
      .catch(function (ex) {
        self.files = null
        self.uploadPercentage = 0
        // self.$store.commit('SET_ALERT', {
        //   show: true,
        //   msg: ex,
        //   color: 'error'
        // })
        console.log('FAILURE!!', ex)
      })
    },

    //  Removes a select file the user has uploaded
    removeFile (key) {
      this.files.splice(key, 1)
    }
  }
}
</script>

<style>
  form {
    display: block;
    height: 70px;
    /* width: 200px; */
    background: rgb(121, 119, 119);
    margin: auto;
    margin-top: 4px;
    text-align: center;
    line-height: 20px;
    border-radius: 4px;
  }
  
  div.progress-bar {
    /* width: 400px; */
    /* margin: auto; */
    padding: 2px;
  }

  div.file-listing {
    width: 400px;
    margin: auto;
    padding: 5px;
    border-bottom: 1px solid #ddd;
  }
  
  div.file-listing img {
    height: 100px;
  }
  
  div.remove-container {
    float: right;
    text-align: right;
  }
  
  div.remove-container a {
    color: red;
    cursor: pointer;
  }
  
  a.submit-button {
    display: block;
    /* margin: auto; */
    text-align: center;
    /* width: 200px; */
    /* padding: 10px;/ */
    text-transform: uppercase;
    background-color: rgb(15, 241, 155);
    color: rgb(27, 13, 228);
    font-weight: bold;
    margin-top: 5px;
    border-radius: 6px;
  }
  
  progress {
    width: 90%;
    /* width: 400px; */
    margin: auto;
    display: block;
    margin-top: 2px;
    margin-bottom: 2px;
  }
</style>

